export function formatLocalDateTime(isoString) {
  if (!isoString) return '';
  const dt = new Date(isoString);
  try {
    return dt.toLocaleString(undefined, {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false,
      timeZoneName: 'short'
    });
  } catch {
    return dt.toString();
  }
}

export function formatLocalDate(isoString) {
  if (!isoString) return '';
  const dt = new Date(isoString);
  try {
    return dt.toLocaleDateString(undefined, {
      year: 'numeric', month: '2-digit', day: '2-digit'
    });
  } catch {
    return dt.toDateString();
  }
}


